import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Push-Benachrichtigungskampagne erstellen',
  sent_title: 'Benachrichtigung eingereiht',
  sent_subtitle:
    'Ihre Push-Benachrichtigung wurde an Apple und Google gesendet. Die Zustellbestätigungen folgen in etwa 15 Minuten.',
  sent_info_banner:
    'Sie können dieses Fenster schließen. Wir prüfen weiter und aktualisieren die Zustellstatistiken automatisch.',
  circles: {
    sent_label: 'Gesendet',
    sent_sub: 'An Abonnenten übergeben',
    delivered_label: 'Zugestellt',
    delivered_sub: 'Warten auf Apple & Google',
    delivered_ready_short: 'Bereit',
    delivered_ready_sub: 'Seite aktualisieren für neue Statistiken',
  },
  scheduled_title: 'Kampagne geplant',
  scheduled_body_line_1: 'Ihre Push-Benachrichtigung ist geplant für {{when}}.',
  scheduled_body_line_2:
    'Wir senden sie automatisch zu diesem Zeitpunkt. Die Zustellbestätigungen von Apple und Google sind ungefähr 15 Minuten nach dem Versand verfügbar.',
  recipients_count_one: 'An {{count}} Empfänger gesendet.',
  recipients_count_other: 'An {{count}} Empfänger gesendet.',
  close: 'Schließen',
  sections: {
    message: 'Nachricht',
    audience: 'Zielgruppe',
    when: 'Sendezeitpunkt',
    review: 'Überprüfung',
  },
  stepper: {
    message: 'Nachricht',
    audience_when: 'Sendezeitpunkt',
    review: 'Überprüfung',
  },
  blocked_reasons: {
    title_required: 'Bitte einen Titel eingeben, um fortzufahren.',
    body_required: 'Bitte einen Nachrichtentext eingeben, um fortzufahren.',
    offer_required: 'Bitte ein Angebot wählen, um fortzufahren.',
    promo_code_required: 'Bitte einen Promo-Code wählen, um fortzufahren.',
    send_option_required: 'Bitte einen Sendezeitpunkt wählen, um fortzufahren.',
    scheduled_at_required: 'Bitte Datum und Uhrzeit wählen, um fortzufahren.',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Benachrichtigungstitel eingeben',
    },
    body: {
      label: 'Nachrichtentext',
      placeholder: 'Geben Sie Ihre Nachricht ein',
    },
    audience: {
      label: 'Zielgruppe',
    },
    send_options: {
      label: 'Sendeoptionen',
    },
    date_and_time: {
      label: 'Datum & Uhrzeit',
      placeholder: 'Datum & Uhrzeit auswählen',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Jetzt senden',
    [SendOptions.Schedule]: 'Planen',
  },
  send_option_cards: {
    now: {
      title: 'Jetzt senden',
      description: 'Sofort an alle Abonnenten senden.',
    },
    schedule: {
      title: 'Planen',
      description: 'Datum und Uhrzeit in der Zukunft wählen.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promo 🚀',
      description: 'Bewerbe ein Angebot oder einen Promo-Code.',
    },
    informational: {
      title: 'Informativ ℹ️',
      description: 'Teile Neuigkeiten oder Updates — ohne Rabatt.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Alle Benutzer ({{count}} Gerät)',
  },
  preview: {
    title: 'Vorschau',
    notifications: {
      title: 'Ihr Benachrichtigungstitel wird hier angezeigt',
      body: 'Ihr Nachrichtentext wird hier mit allen Details angezeigt...',
      now: 'Jetzt',
    },
    estimated_reach: 'Reichweite',
  },
  summary: {
    title: 'Zusammenfassung',
    reach: 'Reichweite',
    when: 'Zeitpunkt',
    campaign_type: 'Kampagnentyp',
    promo_code: 'Promo-Code',
    offer: 'Angebot',
    test_audience: 'Zuerst einen Test senden',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Tägliches Sendelimit erreicht',
      description:
        'Hey! Das Senden von mehr als einer Push-Benachrichtigung pro Tag macht Benutzer unglücklich und kann zur Deinstallation der App führen. Deshalb begrenzen wir manuelle Push-Nachrichten auf 1 pro Tag. Bitte planen Sie dies für morgen ein.',
    },
    offer_not_sendable: {
      title: 'Angebot ist heute nicht gültig',
      description: 'Bitte wählen Sie ein Datum in der Zukunft.',
    },
  },
  buttons: {
    send_now: 'Jetzt senden',
    save: 'Speichern',
    save_as_draft: 'Als Entwurf speichern',
    send_test: 'Test senden',
    draft_with_ai: 'Mit KI entwerfen',
    back: 'Zurück',
    next: 'Weiter',
  },
  feedback: {
    success: 'Kampagne erfolgreich gespeichert',
    promo_code_expired: 'Promo-Code abgelaufen',
    error:
      'Die Kampagne konnte nicht gespeichert werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },
};
